// Environment values are provided at runtime by env-config.js, which Kubernetes mounts next
// to the app's assets from the scheduler-mf-env Secret. The same image therefore runs in
// every environment. In local development the file is missing and the build-time
// process.env values (from .env) are used instead.

// App-specific global: host apps load their own env-config.js too, and some keys (e.g.
// REACT_APP_IMAGE_URL) have different values per app, so they must not share one object.
declare global {
  interface Window {
    __SCHEDULER_ENV__?: Record<string, string | undefined>;
  }
}

declare const __webpack_public_path__: string;

let loading: Promise<void> | undefined;

export function loadRuntimeEnv(): Promise<void> {
  if (!loading) {
    loading = new Promise((resolve) => {
      const script = document.createElement('script');
      // Loaded from this app's own origin, so it also works when embedded in a host app.
      script.src = `${__webpack_public_path__}env-config.js?v=${Date.now()}`;
      script.onload = () => resolve();
      script.onerror = () => resolve();
      document.head.appendChild(script);
    });
  }

  return loading;
}

export function runtimeEnv(key: string, buildTimeValue?: string): string | undefined {
  return window.__SCHEDULER_ENV__?.[key] ?? buildTimeValue;
}
